import { getSiteInfo, getSiteConfigs, setGlobalSiteConfigs, getLazySizesConfig } from '../../SiteConfigs.js';
const HomeFloatingSkyeScrapers = () => import(/* webpackChunkName: "HomeFloatingSkyeScrapers" */ './HomeFloatingSkyScrapers.js');
const HomeVideoWidgetGaEvents = () => import(/* webpackChunkName: "HomeVideoWidgetGaEvents" */ './HomeVideoWidgetGaEvents.js');
const HomeMarketsSkyScraperFix = () => import(/* webpackChunkName: "HomeMarketsSkyScraperFix" */ './HomeMarketsSkyScraperFix.js');

setGlobalSiteConfigs();
let SITE_INFO = getSiteInfo();

var viewport = viewportSize.getWidth();
var prev_viewport = viewport;

if(viewport<768){
    initMobileSlides();
}

$(document).ready(function(){
    
	//IF RCM
	if( site_name == "Markets" ){
		HomeMarketsSkyScraperFix()
        .then(module => {
            module.default();
        });
	}
	
	// auto open second newsletter widget
	if( site_name == "Markets" || site_name == "Energy" || site_name=="Politics" || site_name == 'World' || site_name == 'Defense' || site_name == 'Science' || site_name=="Policy" || site_name=="History"){
		$(".newsletter-signup-container2").last().hide();
        $(".newsletter-widget").css({ "margin-bottom" : "20px" });
	}else{
		$(".newsletter-signup-container2").last().show().css('margin-top', '-15px');
	}
	
	//More From RC Homepage Widget
	//Hide all site related entries on the site being viewed
	$(".more-rc .site a").each(function() {
	   if( $(this).attr("data-site") == site_name ){
		   //console.log("we will hide these links");
		   $(this).parent().hide();
	   }
	});

    init_skyscrapers();

    init_video_ga_events();

}); //END DOC READY

//TEMP USED FOR POLICY/MARKETS KAUFFMAN FOUNDATION CLICKS
window.trackclick_temp_widget = function(event, entry_id, atxt, site){
	
    site = typeof site !== 'undefined' ? site : site_name; 
	site_module='center-column';
	section = site_name+'-widget';
	//Get the href value. Will use at the end to go to link target.
	event = event || window.event;
	var href = '';
	if(event.target.href.length > 2) {
		href = event.target.href;
	} else {
		href = event.target.parentNode.href;
	}
	//Build the params to go to click tracking.
	var url = window.location.protocol+'//util.realclearpolitics.com/trackclicks/trackclick.php?';
	url += 'site='+site+'&';
	if(typeof(entry_id) != 'undefined') url += 'entry_id='+entry_id+'&';
	if(typeof(atxt) != 'undefined') url += 'atxt='+atxt+'&';
	if(typeof(site_module) != 'undefined') url += 'site_module='+site_module+'&';
	url += 'entry_url='+href+'&';
	if(typeof(section) != 'undefined') url += 'section='+section+'&';

	//Wrap click tracking call to prevent premature termination of this function.
	try{
		var tclick = ajaxinclude(url);
		console.log(tclick);
	} catch(err) {}
	if(event.ctrlKey || event.metaKey) {
		return true;
	} else {
		window.setTimeout('document.location = "' + href + '"', 100);
		return false;
	}	
}

//TEMP USED FOR POLICY/MARKETS KAUFFMAN FOUNDATION CLICKS
window.trackclick_cross_domain = function(event, entry_id, atxt, site, permanent, partner_title) {

    site = typeof site !== 'undefined' ? site : 'politics';
	site_module='center-column';
	section = 'More From RC Widget';
	//Get the href value. Will use at the end to go to link target.
	event = event || window.event;
	var href = '';
	if(event.target.href.length > 2) {
		href = event.target.href;
	} else {
		href = event.target.parentNode.href;
	}
	
	var atxt_str = atxt.replace(/'/g, "\\'");
	
	//Build the params to go to click tracking.
	var url = 'http://util.realclearpolitics.com/trackclicks/trackclick.php?';
	url += 'site='+site+'&';
	if(typeof(entry_id) != 'undefined') url += 'entry_id='+entry_id+'&';
	if(typeof(atxt) != 'undefined') url += 'atxt='+atxt+'&';
	if(typeof(site_module) != 'undefined') url += 'site_module='+site_module+'&';
	url += 'entry_url='+href+'&';
	if(typeof(section) != 'undefined') url += 'section='+section+'&';
	if(parseInt(permanent) == 1) url += 'perm='+'1'+'&position=1&partner_title='+partner_title+'&';

	//Wrap click tracking call to prevent premature termination of this function.
	try{
		var tclick = ajaxinclude(url);
		console.log(tclick);
	} catch(err) {}
	if(event.ctrlKey || event.metaKey) {
		return true;
	} else {
		window.setTimeout('document.location = "' + href + '"', 100);
		return false;
	}	
}

function ajaxinclude(url) {
	var page_request = false;
	if (window.XMLHttpRequest) // if Mozilla, Safari etc
		page_request = new XMLHttpRequest();
	else if (window.ActiveXObject){ // if IE	
		try { page_request = new ActiveXObject("Msxml2.XMLHTTP"); } 	
		catch (e){
			try{ page_request = new ActiveXObject("Microsoft.XMLHTTP"); }
			catch (e){  }
		}
	}else
		return false;
		page_request.open('GET', url, false); //get page synchronously 
		page_request.send(null);
		//handle = getpagecontent(page_request);
		//processReturnData(handle); //this functions outputs everything on the page
}

function initMobileSlides(){

    $('.mobile-slider .gamma.tab').css({visibility: 'hidden'});
    $('.mobile-slider .beta-container.tab').css({visibility: 'hidden'});

	// Events used by widgets
	let slider_start    = new Event('hp_slider_start');
	let slider_after    = new Event('hp_slider_after');
	let slider_before   = new Event('hp_slider_before');

	document.dispatchEvent(slider_start);

	// Buttons to swipe 
    window.mobile_slide_status = "alpha";

	$(".mobile-nav-wrapper .left, .mobile-nav-wrapper .arrows.prev").click(function() {

		document.dispatchEvent(slider_before);

		if( window.mobile_slide_status == "gamma" ) {
			return;
		}
		removeSliderAnimationClasses();
		removeSliderNavActive();
		$("body.home #container .mobile-slider").addClass(
			window.mobile_slide_status+"_to_gamma"
		);
		window.mobile_slide_status = "gamma";
		$(".mobile-nav-wrapper .left").addClass("active");

        // $('.mobile-slider .alpha-container.tab').css({visibility: 'hidden'});
        $('.mobile-slider .gamma.tab').css({visibility: 'visible'});
        // $('.mobile-slider .beta-container.tab').css({visibility: 'hidden'});

		document.dispatchEvent(slider_after);
	});

	$(".mobile-nav-wrapper .center").click(function() {

		document.dispatchEvent(slider_before);

		if( window.mobile_slide_status == "alpha" ) {
			return;
		}
		removeSliderAnimationClasses();
		removeSliderNavActive();
		$("body.home #container .mobile-slider").addClass(
			window.mobile_slide_status+"_to_alpha"
		);
		window.mobile_slide_status = "alpha";
		$(this).addClass("active");

        $('.mobile-slider .alpha-container.tab').css({visibility: 'visible'});
        // $('.mobile-slider .gamma.tab').css({visibility: 'hidden'});
        // $('.mobile-slider .beta-container.tab').css({visibility: 'hidden'});

		document.dispatchEvent(slider_after);
	});

	$(".mobile-nav-wrapper .right, .mobile-nav-wrapper .arrows.next").click(function() {

		document.dispatchEvent(slider_before);

		if( window.mobile_slide_status == "beta" ) {
			return;
		}
		removeSliderAnimationClasses();
		removeSliderNavActive();
		$("body.home #container .mobile-slider").addClass(
			window.mobile_slide_status+"_to_beta"
		);
		window.mobile_slide_status = "beta";
		$(".mobile-nav-wrapper .right").addClass("active");

        // $('.mobile-slider .alpha-container.tab').css({visibility: 'visible'});
        // $('.mobile-slider .gamma.tab').css({visibility: 'hidden'});
        $('.mobile-slider .beta-container.tab').css({visibility: 'visible'});

		document.dispatchEvent(slider_after);
	});

	// Arrows to swipe

	$(".flex-direction-nav .flex-prev").click(function() {

		if(window.mobile_slide_status == "gamma") {
			$(".mobile-nav-wrapper .right").click();
		} else if(window.mobile_slide_status == "alpha") {
			$(".mobile-nav-wrapper .left").click();
		} else if(window.mobile_slide_status == "beta") {
			$(".mobile-nav-wrapper .center").click();
		}
	});

	$(".flex-direction-nav .flex-next").click(function() {

		if(window.mobile_slide_status == "gamma") {
			$(".mobile-nav-wrapper .center").click();
		} else if(window.mobile_slide_status == "alpha") {
			$(".mobile-nav-wrapper .right").click();
		} else if(window.mobile_slide_status == "beta") {
			$(".mobile-nav-wrapper .left").click();
		}
	});

	// Apply mobile swipe

	document.addEventListener('touchstart', handleTouchStart, false);        
	document.addEventListener('touchmove', handleTouchMove, false);

	window.xDown = null;                                                        
	window.yDown = null;

	function getTouches(evt) {
	return evt.touches ||             // browser API
	   evt.originalEvent.touches; // jQuery
	}                                                     

	function handleTouchStart(evt) {
		const firstTouch = getTouches(evt)[0];                                      
		xDown = firstTouch.clientX;                                      
		yDown = firstTouch.clientY;                                      
	};                                                

	function handleTouchMove(evt) {
		if ( ! xDown || ! yDown ) {
			return;
		}

		var xUp = evt.touches[0].clientX;                                    
		var yUp = evt.touches[0].clientY;

		var xDiff = xDown - xUp;
		var yDiff = yDown - yUp;

		// Make sure angle is 25 degrees from horizontal as maximum for a horizontal swipe.
		// This is changed from the original 45 degrees.
		var rad = Math.atan2(Math.abs( yDiff ), Math.abs( xDiff ));
		var deg = rad * (180 / Math.PI);

		if ( deg <= 25 ) {/*most significant*/
			if ( xDiff > 0 ) {
				/* left swipe */ 
				$(".flex-direction-nav .flex-next").click();
			} else {
				/* right swipe */
				$(".flex-direction-nav .flex-prev").click();
			}                       
		} else {
			if ( yDiff > 0 ) {
				/* up swipe */ 
			} else { 
				/* down swipe */
			}                                                                 
		}
		/* reset values */
		xDown = null;
		yDown = null;                                             
	};
}

function removeSliderAnimationClasses()
{
	$("body.home #container .mobile-slider").removeClass("alpha_to_beta");
	$("body.home #container .mobile-slider").removeClass("alpha_to_gamma");
	$("body.home #container .mobile-slider").removeClass("beta_to_alpha");
	$("body.home #container .mobile-slider").removeClass("beta_to_gamma");
	$("body.home #container .mobile-slider").removeClass("gamma_to_alpha");
	$("body.home #container .mobile-slider").removeClass("gamma_to_beta");
}

function removeSliderNavActive()
{
	$(".mobile-nav-wrapper .left").removeClass("active");
	$(".mobile-nav-wrapper .center").removeClass("active");
	$(".mobile-nav-wrapper .right").removeClass("active");
}

function init_skyscrapers()
{
    var skyscrapers_allowed_sites = [
		"politics",
		// "defense",
		"world",
		"policy"
	];

	if( $.inArray(siteName, skyscrapers_allowed_sites) > -1 ){

		if( $("body.home").length > 0 && !$('body').hasClass('with-ora') ){
			HomeFloatingSkyeScrapers()
            .then(module => {
                module.default();
            });
		}
	}
}

function init_video_ga_events()
{
    HomeVideoWidgetGaEvents()
    .then(module => {
        module.default();
    });
}